import axios from "axios";
import { Promise } from "core-js";
import { socket, state } from "@/socket";

export default {
  namespaced: true,
  state: {
    tempdata: [],
    tempgraph: {},
  },
  getters: {
    getTemp() {
      return state.tempdata;
    },
  },
  mutations: {
    updateData(state, newVal) {
      state.tempdata = newVal;
    },
    updateTempGraph(state, newVal) {
      state.tempgraph = newVal;
    },
  },
  actions: {
    getTempGraph({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getTempGraph")
          .then((response) => {
            commit("updateTempGraph", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // ------ get temp data ------
    getTempData({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getTempData")
          .then((response) => {
            commit("updateData", response.data);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {},
};
